import { render } from "./HouseQuestion.vue?vue&type=template&id=7f2d871e&scoped=true&ts=true&lang=pug"
import script from "./HouseQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./HouseQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./HouseQuestion.vue?vue&type=style&index=0&id=7f2d871e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2d871e"]])

export default __exports__